module.exports = __webpack_public_path__ + "static/media/veridaLogo.2f1327b8.svg";